import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  NgbModal,
  NgbPopover,
  NgbPopoverConfig,
} from '@ng-bootstrap/ng-bootstrap';
import { RoutingService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { ContractConditions } from 'src/app/shared/model/contract-conditions.model';
import { PriceChannel } from '../../shared/model/price-channel.model';
import { PriceGroup } from '../../shared/model/price-group.model';
import {
  CustomProduct,
  CustomProductApiParams,
} from '../../shared/model/product.model';
import { ProductUtils } from '../../shared/utils/productUtils';
import { CustomProdPgService } from '../custom-prod-pg.service';

@Component({
  selector: 'app-custom-product-card',
  templateUrl: './custom-product-card.component.html',
})
export class CustomProductCardComponent implements OnInit, OnDestroy {
  buttonName: any;
  description: string;
  monograph: any;
  itemInCart: boolean = false;
  monographLink: any;
  @ViewChild('p2') public successPopover: NgbPopover;
  @ViewChild('price') divRef: ElementRef;
  fallbackImage = '../../assets/i18n-assets/sanofiwebb_missing_product.png';
  userDetails: any;
  @Input() iconDisplay: boolean;
  @Input() productInfo: CustomProduct;
  batchInfo = {};
  itemAddedQuantity: any;
  cartId: any;
  cartItems: any;
  successMsg = false;
  updateErrorSub: Subscription;
  userDataSub: Subscription;
  cartItemsSub: Subscription;
  createdCartSub: Subscription;
  updatedCartSub: Subscription;
  conditions: Array<ContractConditions>;
  contractSelected: ContractConditions | undefined;
  contractSelectedId: string;
  hasContractFromCart: boolean = false;
  enableBtn: boolean = false;
  priceToShow: number;
  showPriceGroup: boolean = false;
  priceGroupToShow: any;
  priceToShowGroupId: string;
  conditionsForCartonsLogicMeet = false;
  channelSelected: PriceChannel;
  protected readonly PriceChannel = PriceChannel;
  protected readonly ProductUtils = ProductUtils;

  isProductDescriptionClamped = false;
  @ViewChild('productDescriptionContainer', { static: false })
  set productDescriptionContainer(content: ElementRef) {
    this.isProductDescriptionClamped =
      content?.nativeElement?.offsetHeight <
      content?.nativeElement?.scrollHeight;
  }

  constructor(
    private readonly user: UserAccountFacade,
    private readonly config: NgbPopoverConfig,
    private readonly routingService: RoutingService,
    private readonly plpService: CustomProdPgService,
    protected readonly sanitizer: DomSanitizer,
    private readonly cdr: ChangeDetectorRef,
    protected readonly modal: NgbModal
  ) {
    config.closeDelay = 2000;
    config.openDelay = 1000;
  }

  ngOnInit(): void {
    this.batchInfo = this.productInfo.batchInfo;
    this.monograph = this.productInfo.productDocuments;
    this.conditions = this.productInfo?.conditions;

    this.itemInCart = true;
    this.setMonographLink();
    this.description = this.productInfo.description;
    this.subscribeToUserData();
    this.checkCart('no');
    this.channelSelected = sessionStorage.getItem(
      'selectedChannel'
    ) as PriceChannel;

    this.conditionsForCartonsLogicMeet =
      ProductUtils.channelPrivateAndNumberUnitsPerCartonMoreThanOne(
        this.productInfo?.numberOfUnitsPerCarton,
        this.channelSelected
      );

    if (this.channelSelected === PriceChannel.PRIVATE) {
      this.enableBtn = true;
    } else {
      setTimeout(() => {
        this.handlePublicChannelContractLogic();
      }, 700);
    }

    this.cdr.detectChanges();
  }

  private setMonographLink(): void {
    if (this.monograph?.productDocument) {
      for (const link of this.monograph.productDocument) {
        this.monographLink = this.sanitizer.bypassSecurityTrustResourceUrl(
          link.url
        );
      }
    }
  }

  private subscribeToUserData(): void {
    this.userDataSub = this.user.get().subscribe((res) => {
      this.userDetails = res;
      if (res !== undefined) {
        if (this.productInfo.flu === true) {
          this.buttonName = 'addToCartItems.reserveNow';
        } else {
          this.buttonName = 'addToCartItems.addCart';
        }
      } else {
        this.buttonName = 'addToCartItems.loginToOrder';
      }
    });
  }

  private handlePublicChannelContractLogic(): void {
    const cond = this.productInfo?.conditions;
    const selectedCont = sessionStorage.getItem('contractFromCartApi');
    if (selectedCont) {
      this.handleSelectedContract(cond, selectedCont);
    } else {
      this.handleNoSelectedContract(cond);
    }
    this.cdr.detectChanges();
  }

  private handleSelectedContract(
    cond: ContractConditions[],
    selectedCont: string
  ): void {
    // If there is product in the cart
    if (cond && cond.length >= 1) {
      if (_.some(cond, ['contractId', selectedCont]) === true) {
        const cont = cond.find((item) => item.contractId === selectedCont);
        this.contractSelected = cont;

        if (cont?.priceGroups?.length > 1) {
          this.showPriceGroup = true;
          this.priceGroupToShow = cont?.priceGroups;
        } else {
          this.enableBtn = true;
          this.priceToShow = cont?.priceGroups[0]?.priceData?.value;
          this.priceToShowGroupId = cont?.priceGroups[0]?.groupId;
          this.contractSelectedId = cont?.contractId;
        }
      } else {
        this.enableBtn = false;
        this.priceToShow = null;
        this.priceToShowGroupId = null;
        this.contractSelectedId = null;
        this.cdr.detectChanges();
      }
    }
  }

  private handleNoSelectedContract(cond: ContractConditions[]): void {
    if (cond && cond.length >= 1) {
      if (cond?.length === 1 && cond[0]?.priceGroups?.length === 1) {
        this.priceToShow = cond[0]?.priceGroups[0]?.priceData?.value;
        this.priceToShowGroupId = cond[0]?.priceGroups[0]?.groupId;
        this.contractSelectedId = cond[0]?.contractId;
        this.enableBtn = true;
      } else {
        this.enableBtn = false;
        this.showPriceGroup = true;
        this.contractSelectedId = cond[0]?.contractId;
        this.priceGroupToShow = cond[0]?.priceGroups;
        if (cond.length > 1) {
          this.showPriceGroup = false;
        }
      }
    }
    if (!cond) {
      //Price for products without contracts
      this.priceToShow = this.productInfo?.price?.value;
    }
  }

  showSelectedContract(contract: ContractConditions): void {
    this.contractSelectedId = contract?.contractId;
    this.contractSelected = contract;

    if (contract && contract?.priceGroups?.length === 1) {
      this.enableBtn = true;
      this.priceToShow = contract?.priceGroups[0]?.priceData?.value;
      this.priceToShowGroupId = contract?.priceGroups[0]?.groupId;
    } else {
      this.priceGroupToShow = contract?.priceGroups;
      this.enableBtn = false;
      this.priceToShow = null;
      this.priceToShowGroupId = null;
    }
  }

  get selectedContractName(): string {
    if (!this.conditions || !this.contractSelectedId) {
      return '';
    }
    return (
      this.conditions.find(
        (condition) => condition.contractId === this.contractSelectedId
      )?.contractName || ''
    );
  }

  showSelectPriceGroup(priceGroup: PriceGroup): void {
    this.priceToShow = priceGroup?.priceData?.value;
    this.priceToShowGroupId = priceGroup?.groupId;
    this.enableBtn = true;
  }

  private checkCart(itemAdded: string): void {
    this.cartItemsSub = this.cartItemsSub
      ? this.cartItemsSub
      : this.plpService.cartItems$.subscribe((res) => {
          if (res) {
            this.cartItems = res?.carts;
            // Standard cart only - using saveTime as flag
            this.cartItems = this.cartItems.filter(
              (item) => item?.saveTime === undefined
            );
            // Check if there is item in the cart
            if (
              this.cartItems?.[0]?.childCarts?.[0]?.entries?.length ||
              itemAdded === 'yes'
            ) {
              const childCart = this.cartItems[0]?.childCarts[0];

              if (childCart?.contractId) {
                sessionStorage.setItem(
                  'contractFromCartApi',
                  childCart?.contractId
                );
                sessionStorage.setItem(
                  'contractFromCartApiName',
                  childCart?.contractName
                );
              }

              this.hasContractFromCart = true;
              this.contractSelectedId = childCart?.contractId;
            } else {
              this.hasContractFromCart = false;
              sessionStorage.removeItem('contractFromCartApi');
              sessionStorage.removeItem('contractFromCartApiName');
            }
          } else {
            this.hasContractFromCart = false;
          }
          this.cdr.detectChanges();
        });
  }

  openModal(
    content: TemplateRef<any>,
    prodCode: string,
    prodConditions: ContractConditions[]
  ): void {
    if (
      sessionStorage.getItem('contractFromCartApi') ||
      this.channelSelected === PriceChannel.PRIVATE ||
      !this.channelSelected
    ) {
      this.addToCart(prodCode, prodConditions);
    } else {
      this.modal.open(content, {
        centered: true,
        backdrop: 'static',
      });
    }
  }

  addToCart(productCode: string, conditions: ContractConditions[]): void {
    this.successMsg = true;

    if (this.buttonName === 'addToCartItems.reserveNow') {
      this.navigateToFlu();
      return;
    }

    if (this.buttonName === 'addToCartItems.addCart') {
      const inputElement = document.getElementById(
        `prodQuantity${productCode}`
      ) as HTMLInputElement;

      const params = this.buildCartParams(
        productCode,
        conditions,
        inputElement?.value
      );

      this.itemAddedQuantity = inputElement?.value;

      if (this.cartItems && this.cartItems?.length === 0) {
        this.createCartAndAddProduct(params);
      } else {
        this.ensureCartId();
        this.updateCartDetails(params);
      }
    }
  }

  private buildCartParams(
    productCode: string,
    conditions: ContractConditions[],
    quantity: any
  ): CustomProductApiParams {
    let contractSelectedId: string;
    let contractName: string;
    const defaultParams = {
      product: { code: productCode },
      quantity: quantity,
    };

    if (this.channelSelected === PriceChannel.PUBLIC) {
      if (conditions && conditions.length === 1) {
        contractSelectedId = conditions[0].contractId;
        contractName = conditions[0].contractName;
      } else {
        contractSelectedId = this.contractSelectedId;
        contractName =
          conditions.find(
            (condition) => condition.contractId === contractSelectedId
          )?.contractName || '';
      }
      const extraParams = {
        contractId: contractSelectedId,
        contractName: contractName || '',
        groupId: this.priceToShowGroupId,
      };
      return { ...defaultParams, ...extraParams };
    }

    return { ...defaultParams };
  }

  private createCartAndAddProduct(params: CustomProductApiParams): void {
    this.plpService.createCart(this.userDetails?.userName);
    this.createdCartSub = this.plpService.createdCart$.subscribe((res) => {
      if (res) {
        this.cartId = res?.code;
        this.plpService.getCarts(this.userDetails?.userName);
        this.updateCartDetails(params);
      }
    });
  }

  private ensureCartId(): void {
    if (this.cartId === undefined) {
      this.cartItems =
        this.cartItems && this.cartItems?.length > 0
          ? this.cartItems[this.cartItems?.length - 1]
          : [];
      this.cartId = this.cartItems?.code;
    }
  }

  private updateCartDetails(params: CustomProductApiParams): void {
    this.plpService.updateCart(
      params,
      this.userDetails?.userName,
      this.cartId,
      this.productInfo
    );
    this.updatedCartSub = this.plpService.cartDetailsUpdate$.subscribe(
      (res) => {
        if (res) {
          this.checkCart('yes');

          if (this.successMsg) {
            this.successPopover.open();
            setTimeout(() => this.successPopover.close(), 2500);
            this.successMsg = false;

            if (
              this.channelSelected === PriceChannel.PUBLIC &&
              !sessionStorage.getItem('contractFromCartApi')
            ) {
              window.location.reload();
            }
          }
        }

        this.cdr.detectChanges();
      }
    );
    this.updateErrorSub = this.plpService.updateError$.subscribe((res) => {
      if (res) {
        this.successMsg = false;
      }
    });
  }

  itemSelected(info: CustomProduct): void {
    this.routingService.goByUrl('/product/' + info.code + '/' + info.code);
  }

  navigateToFlu(): void {
    this.routingService.goByUrl('/influenza/dashboard');
  }

  performQuantityComputation(operator: number | null): void {
    ProductUtils.alterQuantity(
      operator,
      this.productInfo.code,
      this.productInfo.quantityPerUnit
    );
  }

  goToLogin(): void {
    this.routingService.goByUrl('/login');
  }

  ngOnDestroy(): void {
    this.updateErrorSub?.unsubscribe();
    this.userDataSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.createdCartSub?.unsubscribe();
    this.updatedCartSub?.unsubscribe();
  }
}
